export const CASH_HISTORY_QUERY = `
  query CashHistory(
    $userId: ID!
    $gameType: GameType
    $limit: Int
    $cursor: Timestamp
    $roomNameContains: String
    $result: CashResultFilter
    $minNetAmount: Float
    $maxNetAmount: Float
    $startTimeFrom: Timestamp
    $startTimeTo: Timestamp
    $minSmallBlind: Float
    $maxSmallBlind: Float
    $minBigBlind: Float
    $maxBigBlind: Float
    $minAnte: Float
    $maxAnte: Float
    $currency: String
    $currencyType: CurrencyTypeFilter
    $sortBy: String
    $sortDirection: String
  ) {
    userCashHandHistory(
      userId: $userId
      gameType: $gameType
      limit: $limit
      cursor: $cursor
      roomNameContains: $roomNameContains
      result: $result
      minNetAmount: $minNetAmount
      maxNetAmount: $maxNetAmount
      startTimeFrom: $startTimeFrom
      startTimeTo: $startTimeTo
      minSmallBlind: $minSmallBlind
      maxSmallBlind: $maxSmallBlind
      minBigBlind: $minBigBlind
      maxBigBlind: $maxBigBlind
      minAnte: $minAnte
      maxAnte: $maxAnte
      currency: $currency
      currencyType: $currencyType
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      items {
        gameId
        roomId
        roomName
        gameType
        tableType
        startedAt
        finishedAt
        blinds { small big ante }
        communityCards
        pot
        currency
        user {
          userId
          username
          seatIndex
          holeCards
          balanceBefore
          balanceAfter
          netAmount
        }
        winners { userId username amount }
      }
      nextCursor
    }
  }
`;

export const MTT_HISTORY_QUERY = `
  query MttHistory(
    $userId: ID!
    $statusIn: [TournamentStatus!]
    $limit: Int
    $cursor: Timestamp
    $nameContains: String
    $result: TournamentResultFilter
    $startTimeFrom: Timestamp
    $startTimeTo: Timestamp
    $minBuyIn: Float
    $maxBuyIn: Float
    $minEntryFee: Float
    $maxEntryFee: Float
    $minGuaranteedPrizePool: Float
    $maxGuaranteedPrizePool: Float
    $minLateRegistrationMinutes: Float
    $maxLateRegistrationMinutes: Float
    $minRegisteredPlayers: Int
    $maxRegisteredPlayers: Int
    $minMaxPlayers: Int
    $maxMaxPlayers: Int
    $isSatellite: Boolean
    $gameType: GameType
    $rebuyEnabled: Boolean
    $addonEnabled: Boolean
    $currency: String
    $currencyType: CurrencyTypeFilter
    $sortBy: String
    $sortDirection: String
  ) {
    userTournamentHistory(
      userId: $userId
      statusIn: $statusIn
      limit: $limit
      cursor: $cursor
      nameContains: $nameContains
      result: $result
      startTimeFrom: $startTimeFrom
      startTimeTo: $startTimeTo
      minBuyIn: $minBuyIn
      maxBuyIn: $maxBuyIn
      minEntryFee: $minEntryFee
      maxEntryFee: $maxEntryFee
      minGuaranteedPrizePool: $minGuaranteedPrizePool
      maxGuaranteedPrizePool: $maxGuaranteedPrizePool
      minLateRegistrationMinutes: $minLateRegistrationMinutes
      maxLateRegistrationMinutes: $maxLateRegistrationMinutes
      minRegisteredPlayers: $minRegisteredPlayers
      maxRegisteredPlayers: $maxRegisteredPlayers
      minMaxPlayers: $minMaxPlayers
      maxMaxPlayers: $maxMaxPlayers
      isSatellite: $isSatellite
      gameType: $gameType
      rebuyEnabled: $rebuyEnabled
      addonEnabled: $addonEnabled
      currency: $currency
      currencyType: $currencyType
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      items {
        tournamentGameId
        tournamentTemplateId
        name
        gameType
        status
        startTime
        endTime
        buyIn
        entryFee
        prizePool
        totalPlayers
        totalHandCount
        user {
          userId
          username
          position
          prize
          eliminatedAt
          rebuyCount
          addonCount
        }
      }
      nextCursor
    }
  }
`;

export const MTT_HANDS_QUERY = `
  query MttHands($userId: ID!, $tournamentGameId: ID!, $limit: Int, $cursor: Timestamp) {
    userTournamentHandHistory(userId: $userId, tournamentGameId: $tournamentGameId, limit: $limit, cursor: $cursor) {
      items {
        handNumber
        tableId
        timestamp
        winners { userId username amount }
        playerBalances { userId username balance }
      }
      nextCursor
    }
  }
`;

export const CASH_HAND_DETAILS_QUERY = `
  query CashHandDetails($userId: ID!, $gameId: ID!) {
    userCashHandDetails(userId: $userId, gameId: $gameId) {
      gameId
      roomName
      gameType
      tableType
      startedAt
      finishedAt
      blinds { small big ante }
      communityCards
      pot
      currency
      user {
        userId
        username
        seatIndex
        holeCards
        balanceBefore
        balanceAfter
        netAmount
      }
      players {
        userId
        username
        initialBalance
        finalBalance
        holeCards
      }
      winners {
        userId
        username
        amount
        handRankName
        handRankValue
      }
      showdownCards {
        userId
        username
        cards
        handRankName
        handRankValue
      }
      turnHistory {
        time
        roundName
        playerId
        username
        action
        amount
        availableActions {
          type
          minAmount
          maxAmount
          timer
          maxIgnoredTurnsBeforeSitOut
        }
      }
    }
  }
`;

export const TOURNAMENT_LEADERBOARD_QUERY = `
  query TournamentLeaderboard($tournamentGameId: ID!) {
    tournamentLeaderboard(tournamentGameId: $tournamentGameId) {
      position
      userId
      username
      prize
    }
  }
`;

export const CASH_CURRENCY_OPTIONS_QUERY = `
  query CashCurrencies($gameType: GameType) {
    cashCurrencyOptions(gameType: $gameType) {
      currency
      currencyType
      baseCurrency
    }
  }
`;
